import React, { useMemo } from "react";
import useAppFormState from "../hooks/useAppFormState";

export const AppFormControllerContext = React.createContext<
    ReturnType<typeof useAppFormState>
>(undefined);

const AppFormProvider: React.FC = (props) => {
    const localState = window.localStorage.getItem("appform_states");
    const initialInfo = {
        quoteGroupId: "",
        digitalAdviceSessionUserID: "",
        applicationToken: "",
        insurer: null,
        applicationId: 0,
        applicants: [],
        ownershipList: [],
        formData: [],
        caseProducts: [],
        ...(localState ? JSON.parse(localState) : {})   // Let local state override defaults
    };
    const appFormState = useAppFormState(initialInfo);

    const data = useMemo(() => ({ ...appFormState }), [appFormState]);

    return (
        <AppFormControllerContext.Provider value={data}>
            <React.Fragment>{props.children}</React.Fragment>
        </AppFormControllerContext.Provider>
    );
};

export default AppFormProvider;
